import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface IntermediateBreadcrumb {
  afterTitle: string;
  title: string;
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  lastTitle$ = new BehaviorSubject<string | null>(null);
  intermediateBreadcrumb$ = new BehaviorSubject<IntermediateBreadcrumb | null>(null);

  setLastTitle(title: string | null) {
    this.lastTitle$.next(title);
  }

  setIntermediateBreadcrumb(breadcrumb: IntermediateBreadcrumb | null) {
    this.intermediateBreadcrumb$.next(breadcrumb);
  }
}
